import type { SortingType } from '../../types';
import type { SourceValue } from '../data/sources';
import { previewSources as previewSourcesData } from '../data/sources';

export type PreparedPreviewsSourcesType = {
  sort: SortingType;
  sources: SourceValue[];
};

export const getPreviewSources = (
  previewSources: string[] = [],
  sort: SortingType = 'date'
) =>
  previewSources.reduce<PreparedPreviewsSourcesType>(
    (acc, alias) => {
      const { source } = previewSourcesData[alias] ?? {};

      return {
        ...acc,
        sources: [...acc.sources, source]
      };
    },
    {
      sort,
      sources: []
    }
  );
